// extracted by mini-css-extract-plugin
module.exports = {"list":"Languages_list__QijcZ","list-item":"Languages_list-item__1ev7V","language":"Languages_language__16tAZ","active":"Languages_active__2HqK5"};